import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import OtpInput from "../OtpInput";
import Spinner from "../../Spinner";
import styles from "../SignUpStep.module.scss";

const VerifyAccountStep = ({ handleResendOtp, isResending, isSubmitting }) => {
  const { t } = useTranslation("signup");
  const { values, errors, touched, setFieldValue, setFieldTouched } = useFormikContext();

  useEffect(() => {
    setFieldValue("otp", "");
    setFieldTouched("otp", false, false);
  }, [setFieldValue, setFieldTouched]);

  return (
    <div className={`field-row i-mb-8 ${styles.verifyStepContainer}`}>
      <div className={`field-block grid-full text-center ${styles.verifyBlock}`}>
        
        <label className={styles.inputLabel}>
          {t("enter_verification_code", "Enter verification code")}
        </label>
        
        <OtpInput
          value={values.otp}
          onChange={(newOtp) => setFieldValue("otp", newOtp)}
          error={touched.otp && errors.otp}
        />

        {touched.otp && errors.otp && (
          <div className={styles.errorMessage}>{errors.otp}</div>
        )}
        
        <div className={styles.resendContainer}>
          <span>{t("didnt_receive_code", "Didn't receive the code?")}</span>{" "}
          <button 
            type="button" 
            onClick={handleResendOtp}
            disabled={isResending || isSubmitting}
          >
            {isResending ? <Spinner className={styles.spinner} /> : t("resend_code", "Resend Code")}
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default VerifyAccountStep;
